import moduleMap from './ModuleMap';
export default class Module {
    constructor () {}
    on(key, callback) {
        moduleMap.listHandler[key] = moduleMap.listHandler[key] || [];
        moduleMap.listHandler[key].push(callback);
        if(this.uid) {
            let selfKey = `${key}::${this.uid}`;
            moduleMap.listHandler[selfKey] = moduleMap.listHandler[selfKey] || [];
            moduleMap.listHandler[selfKey].push(callback);
        }
    }
    triggerEvent(key, data) {
        (moduleMap.listHandler[key] || []).forEach(fn => {
            fn(data);
        })
    }

    addSelfInStore () {
        if(this.uid) {
            window.controlsStore = window.controlsStore || {};
            window.controlsStore[this.uid] = this;
        }
    }
}